<template>
  <div >
    <template v-if="!loading">
      <b-form id="paymentForm" validated novalidate>
        <b-row v-if="listSpkb.length > 0">
          <b-col lg="3">
            <b-form-group label-for="bank" label="Bank">
                <b-form-select id="pic" v-model="paymentForm.bank" required>
                  <template slot="first">
                    <option :value="null" disabled>-- Harap pilih salah satu --</option>
                  </template>
                  <option
                    v-for="(item, index) in listBank"
                    :key="uniqueId('bank_list'+index)"
                    :value="item.value"
                  >{{item.text}}</option>
                </b-form-select>
                <b-form-invalid-feedback>Penanggung jawab faktur harus di pilih.</b-form-invalid-feedback>
              </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group label-for="start_join" label="Tanggal Bayar">
              <v-date-picker
                id="start_join"
                :input-props="{ class: 'form-control', placeholder: 'Tanggal Bergabung', required: ''}"
                v-model="paymentForm.payment_date"
              ></v-date-picker>
              <div
                v-if="paymentForm.payment_date === null"
                class="invalid-feedback-custom"
              >Tanggal bergabung harus di isi.</div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="text-right">
          <b-col lg="12">
            <label><strong>Total: Rp. {{formatPrice(total_all_payment)}}</strong></label>
          </b-col>
        </b-row>

        <table class="attendance table-bordered table-striped table-responsive">
          <thead>
            <tr class="green text-center">
              <th class="width-30">&nbsp;</th>
              <th class="width-300">Customer</th>
              <th class="width-200">Nama Driver</th>
              <th class="width-200">Tanggal Pengiriman</th>
              <th class="width-250">Amount</th>
              <th class="width-250">Pembayaran Terakhir</th>
              <th class="width-250">Hutang</th>
              <th class="width-300">Total Bayar</th>
            </tr>
          </thead>

          <tbody v-if="listSpkb.length > 0">
            <template v-for="(data, key) in listSpkb">
              <tr class="text-center"  :key="uniqueId('employee'+key)">
                <td class="width-30"><input type="checkbox" v-model="paymentForm.action" :id="'action_' + data.order_number" :value="data.order_number" @change="onSelect" /></td>
                <td class="width-300 text-left">{{data.customer_name}}</td>
                <td class="width-200 text-left">{{data.driver_name}}</td>
                <td class="width-200 text-center">{{dateFormat(data.delivery_date)}}</td>
                <td class="width-250 text-right">Rp. {{formatPrice(data.amount)}}</td>
                <td class="width-250 text-right">Rp. {{formatPrice(data.last_payment)}}<br><small v-if="data.last_payment_date !== null"><i>Tanggal: ({{data.last_payment_date}})</i></small></td>
                <td class="width-250 text-right">Rp. {{formatPrice(data.outstanding)}}</td>
                <td class="width-300 text-right"><input class="text-right" style="width:100%" type="number" v-model="paymentForm.total_payment['total_'+data.order_number]" v-bind:disabled="paymentForm.total_payment['total_'+data.order_number] === null" v-on:change="totalAllPayment"></td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <tr class="text-center">
              <td colspan="6" class="width-no-avaiable">No data available</td>
            </tr>
          </tbody>
        </table>
        <br/>
        <template v-if="listSpkb.length > 0">
          <div class="text-right">
            <b-button type="button" size="sm" variant="primary" :disabled="disabledProcess" @click="process">
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </template>
      </b-form>
    </template>

    <template v-else>
      <loading></loading>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import loading from "@/templates/Loading.vue";
import * as moment from "moment";
import { required, between } from "vuelidate/lib/validators";
import interfaces from "@/templates/_interfaces.js";

export default {
  name: "finance-payment-detail-tempo",
  components: { loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    },
    pic: {
      type: [Array, Object],
      default: () => {}
    },
    listSpkb: {
      type: [Array, Object],
      default: () => []
    },
    paymentForm: {
      type: [Array, Object],
      default: () => []
    },
    listBank: {
      type: [Array, Object],
      default: () => []
    },
    total_all_payment: {
      type: Number,
      default: () => 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      colspan: 4
    };
  },
  computed: {
    disabledProcess: function() {
      let disabled = false;
      if(this.paymentForm.bank === null || this.paymentForm.payment_date === null || this.total_all_payment === 0) {
        disabled = true;
      } else {
        disabled = false;
      }
      return disabled;
    }
  },
  methods: {
    reload() {
      this.$emit("reload");
    },
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function() {},
    process: function() {
      if(confirm('Apakah anda ingin memproses pembayaran ini?')) {
        this.$emit("processPayment", this.paymentForm);
      }
    },
    isHoliday: function(day) {
      let today = parseInt(day) < 10 ? "0" + day : day;
      let date = this.year + "-" + this.month + "-" + today;
      let weekOfNumber = moment(date).format("E");
      return weekOfNumber === "6" || weekOfNumber === "7"
        ? "red text-center"
        : "text-center";
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    dateFormat: function(date) {
      return date === null ? "" : moment(date).format("DD MMM YYYY");
    },
    onSelect: function(event) {
      let order_number = event.target.value;
      if(event.target.checked === true) {
         this.paymentForm.total_payment['total_'+order_number] = 0;
      } else {
         this.paymentForm.total_payment['total_'+order_number] = null;
      }
    },
    totalAllPayment: function() {
      let total = 0;
      if(this.paymentForm.action.length > 0) {
        this.paymentForm.action.forEach((value, index, element) => {
          total+=parseInt(this.paymentForm.total_payment['total_'+value]);
        });
      }
      this.$emit("calulateTotal", total);
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
.width-no-avaiable {
	width: 1320px;
}
</style>